import './App.css';
import NavBarLayout from './NavbarLayout';
import {MdAdd} from "react-icons/md";
import {iconColor} from "./colors"
import IconButton from '@mui/material/IconButton';
import logo from "./icons/Animated Logo.gif";

function Sample() {
  return (
    <NavBarLayout rightIcon={
      <IconButton>
        <MdAdd size="3rem" color={iconColor} />
      </IconButton>
    }>
      <header >
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          #OOTD is under construction 👷
        </p>
      </header>
    </NavBarLayout>
  );
}

export default Sample;
